import { render } from "./IconChevronDown.vue?vue&type=template&id=479deb1d"
const script = {}
script.render = render

export default script